var AVATAR_VARIANT;
(function (AVATAR_VARIANT) {
    AVATAR_VARIANT["COLOR"] = "color";
    AVATAR_VARIANT["IMAGE"] = "image";
})(AVATAR_VARIANT || (AVATAR_VARIANT = {}));
var AVATAR_SIZE;
(function (AVATAR_SIZE) {
    AVATAR_SIZE["LARGE"] = "large";
    AVATAR_SIZE["MEDIUM"] = "medium";
    AVATAR_SIZE["SMALL"] = "small";
})(AVATAR_SIZE || (AVATAR_SIZE = {}));
var AVATAR_COLOR;
(function (AVATAR_COLOR) {
    AVATAR_COLOR["YELLOW"] = "yellow";
    AVATAR_COLOR["BLUE"] = "blue";
    AVATAR_COLOR["GREEN1"] = "green1";
    AVATAR_COLOR["PURPLE"] = "purple";
    AVATAR_COLOR["BLUEGRAY"] = "bluegray";
    AVATAR_COLOR["GRAY"] = "gray";
    AVATAR_COLOR["GREEN2"] = "green2";
    AVATAR_COLOR["ORANGE"] = "orange";
    AVATAR_COLOR["RED"] = "red";
})(AVATAR_COLOR || (AVATAR_COLOR = {}));
var AVATAR_ICON_NAMES;
(function (AVATAR_ICON_NAMES) {
    AVATAR_ICON_NAMES["WOMAN_YOUNG_HYPSTER_MIXED"] = "Woman_Young_Hypster_Mixed";
    AVATAR_ICON_NAMES["WOMAN_YOUNG_CURLS_AFRO"] = "Woman_Young_Curls_Afro";
    AVATAR_ICON_NAMES["WOMAN_YOUNG_SHORT_MIXED"] = "Woman_Young_Short_Mixed";
    AVATAR_ICON_NAMES["WOMAN_YOUNG_LONG_MIXED"] = "Woman_Young_Long_Mixed";
    AVATAR_ICON_NAMES["WOMAN_YOUNG_BRAID_INDIGENOUS"] = "Woman_Young_Braid_Indigenous";
    AVATAR_ICON_NAMES["MAN_YOUNG_HYPSTER_MIXED"] = "Man_Young_Hypster_Mixed";
    AVATAR_ICON_NAMES["MAN_YOUNG_CURLS_AFRO"] = "Man_Young_Curls_Afro";
    AVATAR_ICON_NAMES["MAN_YOUNG_SHORT_MIXED"] = "Man_Young_Short_Mixed";
    AVATAR_ICON_NAMES["MAN_YOUNG_LONG_MIXED"] = "Man_Young_Long_Mixed";
    AVATAR_ICON_NAMES["MAN_YOUNG_BRAID_INDIGENOUS"] = "Man_Young_Braid_Indigenous";
    AVATAR_ICON_NAMES["WOMAN_ADULT_HAIR_MIXED"] = "Woman_Adult_Hair_Mixed";
    AVATAR_ICON_NAMES["WOMAN_ADULT_CURLS_AFRO"] = "Woman_Adult_Curls_Afro";
    AVATAR_ICON_NAMES["WOMAN_ADULT_SHORT_MIXED"] = "Woman_Adult_Short_Mixed";
    AVATAR_ICON_NAMES["WOMAN_ADULT_LONG_MIXED"] = "Woman_Adult_Long_Mixed";
    AVATAR_ICON_NAMES["WOMAN_ADULT_BRAID_INDIGENOUS"] = "Woman_Adult_Braid_Indigenous";
    AVATAR_ICON_NAMES["MAN_ADULT_WHITE_MIXED"] = "Man_Adult_White_Mixed";
    AVATAR_ICON_NAMES["MAN_ADULT_CURLS_AFRO"] = "Man_Adult_Curls_Afro";
    AVATAR_ICON_NAMES["MAN_ADULT_LONG_MIXED"] = "Man_Adult_Long_Mixed";
    AVATAR_ICON_NAMES["MAN_ADULT_SHORT_MIXED"] = "Man_Adult_Short_Mixed";
    AVATAR_ICON_NAMES["MAN_ADULT_BRAID_INDIGENOUS"] = "Man_Adult_Braid_Indigenous";
    AVATAR_ICON_NAMES["WOMAN_OLD_HAIR_MIXED"] = "Woman_Old_Hair_Mixed";
    AVATAR_ICON_NAMES["WOMAN_OLD_CURLS_AFRO"] = "Woman_Old_Curls_Afro";
    AVATAR_ICON_NAMES["WOMAN_OLD_SHORT_MIXED"] = "Woman_Old_Short_Mixed";
    AVATAR_ICON_NAMES["WOMAN_OLD_LONG_MIXED"] = "Woman_Old_Long_Mixed";
    AVATAR_ICON_NAMES["WOMAN_OLD_BRAID_INDIGENOUS"] = "Woman_Old_Braid_Indigenous";
    AVATAR_ICON_NAMES["MAN_OLD_HAIR_SIDED"] = "Man_Old_Hair_Sided_Mixed";
    AVATAR_ICON_NAMES["MAN_OLD_CURLS_AFRO"] = "Man_Old_Curls_Afro";
    AVATAR_ICON_NAMES["MAN_OLD_SHORT_MIXED"] = "Man_Old_Short_Mixed";
    AVATAR_ICON_NAMES["MAN_OLD_LONG_MIXED"] = "Man_Old_Long_Mixed";
    AVATAR_ICON_NAMES["MAN_OLD_BRAID_INDIGENOUS"] = "Man_Old_Braid_Indigenous";
    AVATAR_ICON_NAMES["NONE_CAR"] = "None_Car";
    AVATAR_ICON_NAMES["NONE_DOG"] = "None_Dog";
    AVATAR_ICON_NAMES["NONE_CAT"] = "None_Cat";
    AVATAR_ICON_NAMES["NONE_BIRD"] = "None_Bird";
    AVATAR_ICON_NAMES["NONE_PLANT"] = "None_Plant";
})(AVATAR_ICON_NAMES || (AVATAR_ICON_NAMES = {}));

export { AVATAR_VARIANT as A, AVATAR_COLOR as a, AVATAR_SIZE as b, AVATAR_ICON_NAMES as c };
